var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import * as React from 'react';
import { createFilterCell } from './FilterCell';
import { DropDownList } from '@progress/kendo-react-dropdowns';
var booleanOperator = 'eq';
var settings = {
  emptyFilter: {
    operator: booleanOperator,
    value: ''
  },
  inputComponent: function inputComponent(_props) {
    return null;
  },
  operatorComponent: function operatorComponent(props, cellProps) {
    var _a = cellProps.filter,
        filter = _a === void 0 ? [] : _a,
        field = cellProps.field;
    var current = filter.find(function (f) {
      return f.field === field;
    });
    return React.createElement(DropDownList, __assign({}, props, {
      value: props.data.find(function (x) {
        return x.operator === (current ? current.value : '');
      }),
      onChange: function onChange(e) {
        if (!cellProps.onFilterChange) {
          return;
        }

        var value = e.target.value.operator;

        if (value === '') {
          if (current) {
            cellProps.onFilterChange.call(undefined, {
              filter: filter.filter(function (f) {
                return f.field !== current.field;
              }),
              field: field,
              syntheticEvent: e.syntheticEvent
            });
          }

          return;
        }

        var filterResult = current ? filter.map(function (f) {
          return f.field === field ? __assign({}, current, {
            value: value
          }) : f;
        }) : filter.concat([{
          value: value,
          field: field,
          operator: booleanOperator
        }]);
        cellProps.onFilterChange.call(undefined, {
          filter: filterResult,
          field: field,
          syntheticEvent: e.syntheticEvent
        });
      }
    }));
  }
};
/**
 * @hidden
 */

var BooleanFilterCell = function (_super) {
  __extends(BooleanFilterCell, _super);

  function BooleanFilterCell() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return BooleanFilterCell;
}(createFilterCell(settings));

export { BooleanFilterCell };